import React from 'react';

const LegacyCorpCss = () => {
  return (
    <style jsx global>{`
      html,
      body,
      #root,
      #__next,
      .nextjsWrapperDiv,
      #__next [data-reactroot] {
        height: 100%;
        width: 100%;
        display: block;
        margin: 0;
        padding: 0;
        /*color: #fff;*/
      }

      * {
        box-sizing: border-box;
      }

      #react-root {
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow: hidden;
      }

      #body {
        color: #333;
      }

      .fieldset {
        border: 0;
        display: flex;
        flex-direction: column;
        padding: 0;
      }

      .fieldset.fieldset--horizontal {
        flex-direction: row;
      }

      .horizontal__selects {
        display: flex;
        justify-content: space-between;
      }

      .fieldset--long {
        width: 300px;
      }

      .fieldset--short {
        width: 150px;
      }

      .fieldset input[type='text'] {
        width: 300px;
        padding: 14px 16px;
        font-size: 14px;
      }

      .fieldset textarea {
        width: 600px;
        padding: 14px 16px;
        font-size: 14px;
        min-height: 300px;
      }

      .explanation {
        font-size: 12px;
      }

      .page--exams .react-datepicker__input-container {
        margin-top: auto;
        margin-bottom: auto;
      }

      .page--exams input[type='text'] {
        padding-top: 7px;
        padding-bottom: 7px;
      }

      .formatter--text {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        display: flex;
        align-items: center;
        min-width: 0;
        font-size: 14px;
        height: 100%;
        margin-right: 10px;
      }

      .react-grid-Cell__value {
        height: 100%;
      }

      .formatter--percent {
        margin-top: auto;
        margin-bottom: auto;
        display: flex;
        height: 100%;
        align-items: center;
        justify-content: space-between;
        padding-left: 5px;
        padding-right: 5px;
      }

      .percent-progress {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        height: 100%;
        z-index: 0;
        background-color: #26b2c3;
      }
      .react-grid-Header {
        border-bottom: 1px solid #ddd;
      }
      .react-grid-HeaderCell {
        display: flex !important;
        justify-content: flex-start;
        align-items: center;
        align-self: center;
      }

      .react-grid-Row {
        display: flex;
        align-items: center;
      }

      .percent-content {
        color: #fff;
        text-shadow: 0px 0px 1px #333;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .formatter--list {
        display: flex;
        align-items: center;
        height: 100%;
      }

      .task__header-text {
        overflow: hidden !important;
        width: 100% !important;
      }

      .fieldset--btns {
        display: flex;
        flex-direction: row;
      }

      /* ---------- buttons ------------------------------------------------- */

      .btn {
        margin-left: auto;
        margin-right: auto;

        appearance: none;
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
      }

      .btn.o__left {
        margin-left: 0;
      }

      .btn.o__danger {
        background-color: #c51919;
      }

      .btn.o__danger:hover {
        background-color: rgb(177, 23, 23);
      }

      .btn.o__short {
        height: 35px;
      }

      .btn.o__xshort {
        height: 25px;
        font-size: 10px;
      }

      .btn.o__xskinny {
        width: 75px;
      }

      .btn.o__skinny {
        width: 100px;
      }

      .btn.o__disabled,
      .button.o__disabled {
        opacity: 0.5;
      }

      .btn.o__disabled:hover,
      .button.o__disabled:hover {
        opacity: 0.5;
        cursor: default;
        background: #26b2c3;
      }

      .btn.o__loading {
        opacity: 0.75;
      }

      .btn.o__loading:hover {
        opacity: 0.75;
        cursor: default;
        background: #26b2c3;
      }

      .btn .double-spinner {
        width: 10px;
        height: 10px;
      }

      /* ---------- spacers ------------------------------------------------- */

      .hsp__3 {
        width: 30px;
        height: 1px;
        display: block;
        flex: 0 0 30px;
        content: '';
      }

      .hsp__2 {
        width: 20px;
        height: 1px;
        display: block;
        flex: 0 0 20px;
        content: '';
      }

      .hsp__15 {
        width: 15px;
        height: 1px;
        display: block;
        flex: 0 0 15px;
        content: '';
      }

      .hsp__05 {
        width: 5px;
        height: 1px;
        display: block;
        flex: 0 0 5px;
        content: '';
      }

      .hsp__1 {
        width: 10px;
        height: 1px;
        display: block;
        flex: 0 0 10px;
        content: '';
      }

      .sp__05 {
        display: block;
        height: 5px;
        width: 1px;
      }

      .sp__15 {
        display: block;
        height: 15px;
        width: 1px;
      }

      .sp__1 {
        display: block;
        height: 10px;
        width: 1px;
      }

      .sp__2 {
        display: block;
        height: 20px;
        width: 1px;
      }

      .sp__3 {
        display: block;
        height: 30px;
        width: 1px;
      }

      .sp__5 {
        display: block;
        height: 50px;
        width: 1px;
      }

      /* ---------- global scrollbar style ---------------------------------- */

      .branded-scroll--neutral {
        overflow: auto;
      }

      .branded-scroll--neutral::-webkit-scrollbar {
        -webkit-appearance: none;
        width: 8px;
        height: 8px;
      }

      .branded-scroll--neutral::-webkit-scrollbar-corner,
      .branded-scroll--neutral::-webkit-scrollbar-track-piece {
        background-color: transparent;
      }

      .branded-scroll--neutral::-webkit-scrollbar-thumb {
        border-radius: 100px;
        height: 0px;
        background-color: rgba(0, 0, 0, 0.5);
      }

      .branded-scroll--neutral::-webkit-scrollbar-track {
        background-color: transparent;
      }

      .branded-scroll {
        overflow: auto;
      }

      .branded-scroll::-webkit-scrollbar {
        -webkit-appearance: none;
        width: 10px;
        height: 10px;
      }

      .branded-scroll::-webkit-scrollbar-corner,
      .branded-scroll::-webkit-scrollbar-track-piece {
        background-color: transparent;
      }

      .branded-scroll::-webkit-scrollbar-thumb {
        border-radius: 100px;
        height: 0px;
        background-color: #247eff;
      }

      .branded-scroll::-webkit-scrollbar-track {
        background-color: transparent;
      }
    `}</style>
  );
};

export default LegacyCorpCss;
